import {
  auth,
  createUserWithEmailAndPassword,
  serverTimestamp,
} from "../firebase";
import { getDocument, getDocuments, setDocument } from "./firestoreServices";
import { USERS_COLLECTION } from "../constants/collections";

const createUser = async (
  userCredential: { user: { uid: string } },
  data: {
    email: string;
    role: string;
    firstName: string;
    lastName: string;
    birthDate?: string;
  },
) => {
  const userId = userCredential.user?.uid;
  if (!userId) {
    throw new Error("User ID is required.");
  }

  await setDocument(USERS_COLLECTION, userId, {
    email: data.email,
    createdAt: serverTimestamp(),
    role: data.role,
    deleted: false,
    firstName: data.firstName,
    lastName: data.lastName,
    birthDate: data.birthDate || null,
    fullName: `${data.firstName} ${data.lastName}`,
    fullNameSearch: `${data.firstName} ${data.lastName}`.toLowerCase(),
    avatarUrl: "",
  });

  return userId; // Возвращаем идентификатор пользователя, если необходимо
};

export const signUp = async (data: {
  email: string;
  password: string;
  role: string;
  firstName: string;
  lastName: string;
  birthDate?: string;
}) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      data.email,
      data.password,
    );
    await createUser(userCredential, {
      email: data.email,
      role: data.role,
      firstName: data.firstName,
      lastName: data.lastName,
      birthDate: data.birthDate,
    });

    return userCredential;
  } catch (error) {
    throw error;
  }
};

export const getUser = (uid: string) => {
  return getDocument(USERS_COLLECTION, uid);
};

export const fetchCompanyData = async (userEmail: string) => {
  try {
    const invitations = await getDocuments("invitations", {
      where: [{ field: "email", operator: "==", value: userEmail }],
    });

    if (invitations.length > 0) {
      const data = invitations.sort(
        (a: { updatedAt: number }, b: { updatedAt: number }) =>
          b.updatedAt - a.updatedAt,
      )[0];
      return {
        name: data.companyName,
        id: data.companyId,
        type: data.companyType,
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching company data:", error);
    return null;
  }
};
